import React from "react";

import { withRouter } from "react-router";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ErrorIcon from "@material-ui/icons/Error";

import Button from "common/components/CustomButtons/Button.jsx";

import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

import config from "config";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  snackbar: {
    backgroundColor: "#d32f2f",
    marginTop: "30px",
    maxWidth: "800px",
  },
  message: {
    display: "flex",
    alignItems: "center",
    maxWidth: "450px",
  },
  errorIcon: {
    marginRight: "10px",
  },
  anchor: {
    textTransform: "none",
    fontWeight: "bold",
    color: "#fff",
    "&:hover": {
      color: "white",
    },
  },
};

const PositionedSnackbar = function (props) {
  const [state, setState] = React.useState({
    open: true,
    vertical: "top",
    horizontal: "center",
  });

  const { classes } = props;

  const { vertical, horizontal, open } = state;

  function handleClose() {
    setState({ ...state, open: false });
  }

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        key={`${vertical},${horizontal}`}
        open={open}
      >
        <SnackbarContent
          className={classes.snackbar}
          aria-describedby="message-id"
          message={
            <div id="message-id" className={classes.message}>
              <ErrorIcon className={classes.errorIcon} />
              <Button
                link={true}
                color="transparent"
                className={classes.anchor}
                onClick={() => {
                  props.history.push(
                    config.MYACCOUNT.APP_PATH + "/user/important"
                  );
                }}
              >
                {window.innerWidth > 580
                  ? "You have an important message on your account. Click here to open it"
                  : "Important!"}
              </Button>
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
};

export default withStyles(styles)(withRouter(PositionedSnackbar));
